import { Injectable } from '@angular/core';
import { Http, Headers, BaseRequestOptions, RequestOptions, RequestMethod, Jsonp, URLSearchParams } from '@angular/http';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise'
import { Subject } from 'rxjs/Subject'
import { Storage } from '@ionic/storage';
//Providers
import { ConfigProvider } from '../providers/config-provider';
import { AuthProvider } from '../providers/auth-provider';
import { HubProvider } from '../providers/hub-provider';
//Models
import { Url } from '../models/url.model';
import { EventSelect } from '../models/event.model';
import { DayProgram } from '../models/day-program.model';
import { Activity } from '../models/activity.model';
import { User } from '../models/user.model';
import { Congresso } from '../models/congresso.model';
import { Program } from '../models/program.model';
import { AreaProgram } from '../models/area.program.model';



@Injectable()
export class CongressoProvider {
    private result;
    public headers: Headers;
    public options: RequestOptions;
    public urlCongresso = new Url;
    public params = new URLSearchParams();
    public user: User;
    private congresso: Congresso;

    constructor(public http: Http,
        public jsonp: Jsonp,
        public storage: Storage,
        public auth: AuthProvider,
        public hub: HubProvider,

        public configProvider: ConfigProvider) {
        this.urlCongresso = configProvider.url;
        this.headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': this.urlCongresso.SgunAuthorization, 'MobileReferer': this.urlCongresso.SgunReferer });
        this.options = new RequestOptions({ headers: this.headers });

        this.user = JSON.parse(localStorage.getItem('user')) as User;

        this.params.set('format', 'json');
        this.params.set('callback', this.configProvider.CALLBACK);
        if (localStorage.getItem('congresso') != null && localStorage.getItem('congresso') != "undefined") {
            this.congresso = JSON.parse(localStorage.getItem('congresso')) as Congresso;
        }
        else {
            localStorage.removeItem('congresso');
            this.congresso = new Congresso();
        }
    }

    GetAll(): Promise<EventSelect[]> {
        //this.jsonp.get(this.urlCongresso.Cientifico + '/shared/apc/getAllCongressos.ashx').map(res => res.json());
        var self = this;
        let params1 = new URLSearchParams();
        params1.set('format', 'json');
        params1.set('callback', "JSONP_CALLBACK");

        return this.jsonp.get(this.urlCongresso.Cientifico + `/shared/apc/getAllCongressos.ashx?`, { search: params1 })
            .map(res => res.json() as EventSelect[]).toPromise();
    }

    getProgramaCompleto(eventoAno) {
        this.hub.config('');
        return this.hub.connection.start().then((data) => {
            return this.hub.connection.invoke('Init', eventoAno);
        });
    }

    getCompleteProgramNoRealTime(congressoAno: number, guidUsuario: string, tipoAssociacaoId: string, categoriaId: number): Promise<Array<any>> {
        let param = this.params;
        param.set('congressoAno', <any>congressoAno);
        param.set('guidUsuario', guidUsuario);
        param.set('busca', '');
        param.set('isAgenda', 'false');
        param.set('tipoAssociacaoId', <any>tipoAssociacaoId)
        param.set('categoriaId', <any>categoriaId)
        return this.jsonp.get(this.urlCongresso.Cientifico + '/congresso/shared/getProgramaCompleto.ashx', { search: param })
            .map(res => res.json()).toPromise()
            .then(data => {
                if (data) {
                    
                    var result = data.programa[0].Area ? data.programa as Array<AreaProgram> : data.programa as Array<DayProgram>
                    return result;
                }
            });
    }

    getAtividadeById(id: number): Promise<Activity> {

        let param = this.params;
        let guid = this.user ? this.user.Guid : '';
        param.set('id', <any>id);
        param.set('guidUsuario', guid);
        param.set('congressoAno', <any>this.congresso.Ano);
        return this.jsonp.get(this.urlCongresso.Cientifico + `/shared/apc/getAtividadeById.ashx?`, { search: param })
            .map(res => res.json()).toPromise()
            .then(data => {
                if (data && data.resposta.codigo == 0)
                    return data.resposta.retorno as Activity;

            });
    }

    confirmarPresenca(atividadeId: number, participar: boolean): Promise<any> {
        this.user = this.auth.refreshAuth();
        let param = this.params;
        param.set('usuarioGuid', this.user.Guid);
        param.set('usuarioLogin', this.user.Login);
        param.set('usuarioSgunId', <any>this.user.SgunId);
        param.set('tipoAssociacaoId', <any>this.user.TipoAssociacaoId);
        param.set('categoriaId', <any>this.user.CategoriaId);
        param.set('atividadeId', <any>atividadeId);
        param.set('participar', <any>participar);

        return this.jsonp.get(this.urlCongresso.Cientifico + '/congresso/shared/confirmarPresencaHandler.ashx', { search: param })
            .map(res => res.json()).toPromise();
    }

    substituirPresenca(adicionarAtividadeId: number, apagarAtividadeId: number, usuarioGuid: string, usuarioLogin: string, tipoAssociacaoId: number, categoriaId: number) {

        let param = this.params;
        param.set('adicionarAtividadeId', <any>adicionarAtividadeId);
        param.set('apagarAtividadeId', <any>apagarAtividadeId);
        param.set('guid', usuarioGuid);
        param.set('login', usuarioLogin);
        param.set('tipoAssociacaoId', <any>tipoAssociacaoId);
        param.set('categoriaId', <any>categoriaId);

        return this.jsonp.get(this.urlCongresso.Cientifico + '/congresso/shared/substituirPresencaAtividade.ashx', { search: param })
            .map(res => res.json()).toPromise();

    }


    confirmarPresencaAtividade(atividadeId: number, participar: boolean): Promise<any> {
        this.user = this.auth.refreshAuth();

        let param = JSON.stringify({
            participar: participar,
            atividadeId: atividadeId,
            guid: this.user.Guid,
            sgunId: this.user.SgunId,
            login: this.user.Login,
            tipoAssociacaoId: this.user.TipoAssociacaoId,
            categoriaId: this.user.CategoriaId,
            nome: this.user.Nome,
            email: ''
        });

        this.hub.config('');
        return this.hub.connection.start().then((data) => {

            return this.hub.connection.invoke('ConfimarPresencaAtividade', param);
        });
    }

    substituirPresencaAtividade(adicionarAtividadeId: number, apagarAtividadeId: number, usuarioGuid: string, usuarioLogin: string, tipoAssociacaoId: number, categoriaId: number) {

        let param = JSON.stringify({
            adicionarAtividadeId: adicionarAtividadeId,
            apagarAtividadeId: apagarAtividadeId,
            guid: usuarioGuid,
            login: usuarioLogin,
            tipoAssociacaoId: tipoAssociacaoId,
            categoriaId: categoriaId
        });

        this.hub.config('');

        return this.hub.connection.start().then((data) => {
            return this.hub.connection.invoke('SubstituirPresencaAtividade', param);
        });
    }

    confirmarVisualizacao(atividadeId: number, cofirm: boolean) : Promise<any>{
        this.user = this.auth.refreshAuth();
        let param = this.params;
        param.set('usuarioGuid', this.user.Guid);
        param.set('usuarioLogin', this.user.Login);
        param.set('usuarioSgunId', <any>this.user.SgunId);
        param.set('tipoAssociacaoId', <any>this.user.TipoAssociacaoId);
        param.set('categoriaId', <any>this.user.CategoriaId);
        param.set('atividadeId', <any>atividadeId);
        param.set('confirmar', <any>cofirm);

        return this.jsonp.get(this.urlCongresso.Cientifico + '/congresso/shared/ConfirmarVisualizacao.ashx', { search: param })
            .map(res => res.json()).toPromise();
    }

}



// WEBPACK FOOTER //
// ./src/providers/congresso-provider.ts